import React from 'react';
import styles from './title-desc.scss';

interface TitleDescProps {
  className?: string;
  title: string;
  desc?: string;
  style?: React.CSSProperties;
}

export const TitleDesc = ({ className, title, desc, style = {} }: TitleDescProps) => (
  <div className={className} style={style}>
    <h1 className={styles.title}>{title}</h1>
    {desc && <h2 className={styles.desc}>{desc}</h2>}
  </div>
);
